import { SVGProps } from 'react';

function EyeCrossed(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={25}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m2.783 19 18.75-18M8.964 17.051A9.985 9.985 0 0 0 12 17.5c4.1.069 8.258-2.813 10.824-5.637.57-.633.57-1.593 0-2.226A20.571 20.571 0 0 0 19.75 6.88M14.413 4.282A9.549 9.549 0 0 0 12 4C7.969 3.933 3.8 6.752 1.179 9.635a1.663 1.663 0 0 0 0 2.226 20.8 20.8 0 0 0 2.6 2.4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 10.75A3.749 3.749 0 0 1 12 7M15.75 10.749v0A3.75 3.75 0 0 1 12 14.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

EyeCrossed.defaultProps = {
  role: 'graphics-document',
};

export default EyeCrossed;
